import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { AgGridReact } from 'ag-grid-react';
import { useMemo, useState } from "react";
import ErrorPage from "../../Layouts/Error";
import Loading from "../../Layouts/Loading";
import { fa_dateـetime } from "../../utils/Persian";
import { useGetAllUserExamsQuery } from "../../Redux/Apis/userExamApi";
import { ICellRendererParams, ValueFormatterParams } from "@ag-grid-community/core";
import Answersheet from "../../Sections/panel/exam/Answersheet";
import { Link } from "react-router-dom";
import PerformanceSummary from "../../Sections/panel/exam/PerformanceSummary";

function UserExams() {
    const [ansersheet,setAnswersheet] = useState(false)
    const [performanceSummary,setPerformanceSummary] = useState(false)
    const [examId,setExamId] = useState(0)
    const pagination = true;
    const paginationPageSize = 500;
    const paginationPageSizeSelector = [200, 500, 1000];
    // const check_status = (st:string) => {
    //     return st === 'PENDING' ? "در حال انجام" : "تکمیل شده"
    // }
    const CustomButtonComponent = (props: { values: number; })  => {
        return (
            <div>
                <Link to={`/panel/exam/review/${props.values}`} className="btn btn-primary btn-sm">
                    <FontAwesomeIcon className="me-1" icon={"eye"}/>بررسی آزمون
                </Link>
                <button
                    className="btn btn-success border border-secondary-subtle border-4 btn-sm ms-2"
                    onClick={() => {setExamId(+props.values); setAnswersheet(true)} }
                >
                    <FontAwesomeIcon icon={"list-check"} className="me-1"/> مشاهده پاسخنامه
               </button>
                <button
                    className="btn btn-warning btn-sm ms-2"
                    onClick={() => {setExamId(+props.values); setPerformanceSummary(true)}}
                >
                    <FontAwesomeIcon className="me-1" icon={"chart-column"}/>نتیجه عملکرد
                </button>
            </div>
        );
        };

    const [colDefs] = useState([
        {
            headerName: "#",
            valueFormatter: (params: ValueFormatterParams) => {
                return `${parseInt(params.node!.id!) + 1}`;
            },
            flex: 0.15
        },
        { headerName: 'نام آزمون', valueGetter: (p: { data: { Exam: { name: string }; }; }) => p.data?.Exam?.name ,flex: 1},
        { headerName: 'تاریخ آزمون', field: "create_date", valueFormatter: (p: { data: { create_date: any; }; }) => fa_dateـetime(p.data.create_date),flex: 0.3},
        // { headerName: 'نمره', field: "score" ,valueFormatter: (p: { data: { score: string; }; }) =>  p.data.score + "%", flex: 0.2},
        // { headerName: 'وضعیت', field: "status",valueFormatter: (p: { data: { status: string; }; }) =>  check_status(p.data.status),flex: 0.4},
        {
            field: "actions",
            headerName: "",
            cellRendererSelector: (params: ICellRendererParams) => {
                return {
                    component: CustomButtonComponent,
                    params: { values: params.data.id },
                };
            },
            flex: 1,
        },
      ]);

      const defaultColDef = useMemo(() => {
        return {
            flex: 1,
        }
    }, []);

    const {
        data,
        isLoading,
        isSuccess,
        isError,
        error,
    } = useGetAllUserExamsQuery()

    if(isError) return <ErrorPage data={error}/>
    
    return ( 
        <>
        <main className="col-lg-9">
            <div className="panel-surface p-3 mb-3 d-flex align-items-center justify-content-between">
                <h6 className="fw-bold m-0">نتایج آزمون‌ها</h6>
                <span className="panel-muted small">لیست آخرین نتایج شما</span>
            </div>

            <div className="panel-surface p-3">
                {isLoading && <Loading/>}
                {isSuccess && data &&  
                    <div className="ag-theme-quartz" style={{ height: 500 }}>
                        <AgGridReact
                            rowData={data}
                            columnDefs={colDefs as any}
                            enableRtl={true}
                            defaultColDef={defaultColDef}
                            rowSelection="single"
                            pagination={pagination}
                            paginationPageSize={paginationPageSize}
                            paginationPageSizeSelector={paginationPageSizeSelector}
                        />
                    </div> }
            </div>
        </main>

        {ansersheet && <Answersheet userExamId={examId} close={setAnswersheet}/>}
        {performanceSummary && <PerformanceSummary userExamId={examId} close={setPerformanceSummary} />}
        </>
    );
}

export default UserExams;
